







import OptionRadioSelector from "../../../system/selectors/OptionRadioSelector.vue";
import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../system/mixins";
import { StandardOption } from "../../../system/selectors/mixins";

@Component({
  components: {
    selector: OptionRadioSelector,
  },
})
export default class ImageLocatorMenu extends Mixins(ModelEditableMixin) {
  data(): any {
    return {
      options: [
        ImageLocatorMenu.toOption("実サイズ", true),
        ImageLocatorMenu.toOption("ドラッグ", false),
      ],
    };
  }
  options: StandardOption<boolean>[];

  private static toOption(label: string, shouldLocate: boolean): StandardOption<boolean> {
    return new StandardOption<boolean>(
      label,
      shouldLocate,
      ""
    );
  }
}
